import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Iframely as IframelyAtom } from 'components/atoms/iframely';
import { FilterBar } from 'components/molecules/filter-bar';
import { Caption01, Text02 } from 'components/styles';

export const TabIframeWrapper = styled.div<{ isPointerEventsEnabled: boolean }>`
  padding: 0;
  overflow: hidden;
  display: flex;
  position: relative;
  width: 100%;
  pointer-events: ${(props) =>
    props?.isPointerEventsEnabled ? 'auto' : 'none'};
`;

export const Iframely = styled(IframelyAtom)<{ height: number }>`
  overflow: auto;
  iframe {
    height: ${(props) => `${props?.height}px`} !important;
  }
  position: relative;
  flex-grow: 1;
  transition: flex-basis var(--animation-duration-slow);
`;

export const IframeWrapper = styled.div<{ height: number }>`
  iframe {
    width: 100%;
    height: ${(props) => `${props?.height}px`} !important;
  }
  position: relative;
  flex-grow: 1;
  transition: flex-basis var(--animation-duration-slow);
  overflow: auto;
`;

export const LoadingWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50vh;
`;

export const FilterBarSecondary = styled(FilterBar.Secondary)`
  && .ant-btn:not(.ant-btn-icon-only) svg {
    margin: unset;
    margin-right: var(--layout-01);
  }
`;

export const EmbeddedBy = styled.div`
  ${Caption01};
  ${Text02};
`;

export const PrivatePlacardHolder = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
`;
export const PrivatePlacard = styled.div`
  background: var(--private-02);
  left: 0;
  right: 0;
  padding: var(--spacing-03) var(--spacing-05);
  z-index: 1;
`;

export const AbsolutePrivatePlacard = styled(PrivatePlacard)`
  position: absolute;
  box-shadow: var(--shadow-02);
`;

export const StyledSidebarToggleButton = styled(Button)`
  position: relative;
  padding: var(--spacing-02);
  margin-right: var(--spacing-03);
`;
